import React, { useState } from "react"
import { Link } from "gatsby"

const IconCog = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" /><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
)

const IconGrid = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" /><rect x="14" y="3" width="7" height="7" /><rect x="14" y="14" width="7" height="7" /><rect x="3" y="14" width="7" height="7" />
  </svg>
)


const IconLightbulb = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="9" y1="18" x2="15" y2="18" /><line x1="10" y1="22" x2="14" y2="22" /><path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
  </svg>
)

const TABS = [
  {
    key: "services",
    Icon: IconCog,
    title: "Services",
    desc: "AI-driven web, mobile & custom software",
    bg: "#eff6ff",
    ic: "#1b2d8e",
    centerLabel: "Our Services",
    links: [
      { to: "/services/webdevelopment",    label: "AI-Powered Web Development" },
      { to: "/services/mobiledevelopment", label: "AI-Accelerated Mobile App Development" },
      { to: "/services/staffaugmentation", label: "Staff Augmentation" },
      { to: "/services/aisolution",        label: "AI-Native Development" },
    ],
  },
  {
    key: "erp",
    Icon: IconGrid,
    title: "ERP Implementation and Support",
    desc: "Microsoft Dynamics 365 & Odoo ERP solutions",
    bg: "#faf5ff",
    ic: "#7c3aed",
    centerLabel: "ERP Services",
    links: [
      { to: "/dynamics365/financeOperations", label: "Microsoft Dynamics 365 Maintenance and Support" },
      { to: "/Odoo/implementationPartner",    label: "Odoo Implementation" },
    ],
  },
  {
    key: "solutions",
    Icon: IconLightbulb,
    title: "Solutions",
    desc: "Ready-made products for your business",
    bg: "#f0fdf4",
    ic: "#16a34a",
    centerLabel: "Our Products",
    links: [
      { to: "/caseStudies/products/visioedge",                   label: "Visioedge – ERP Solution" },
      { to: "/caseStudies/products/viztos",                      label: "Viztos – Cafe / Oil Management" },
      { to: "/caseStudies/products/mD365BulkStockDistribution",  label: "D365 Bulk Stock Distribution" },
      { to: "/caseStudies/products/classManagement",             label: "Class Management Solution" },
      { to: "/caseStudies/products/donationCampaignManagement",  label: "Donation Campaign Management" },
    ],
  },
]

const HowWeHelp = () => {
  const [active, setActive] = useState("services")
  const tab = TABS.find(t => t.key === active)

  return (
    <div className="mega-menu">
      {/* Left: category tabs */}
      <div className="mega-menu__left">
        <p className="mega-menu__section-label">Categories</p>
        {TABS.map(({ key, Icon, title, desc, bg, ic }) => (
          <button
            key={key}
            className={`mega-menu__nav-item${active === key ? " is-active" : ""}`}
            onClick={() => setActive(key)}
          >
            <div className="mega-menu__nav-icon" style={{ background: bg }}>
              <Icon style={{ color: ic }} />
            </div>
            <div className="mega-menu__nav-text">
              <strong>{title}</strong>
              <span>{desc}</span>
            </div>
          </button>
        ))}
      </div>

      {/* Center: links for selected tab */}
      <div className="mega-menu__center">
        <p className="mega-menu__section-label">{tab.centerLabel}</p>
        {active === "erp" ? (
          <div className="mega-menu__erp-layout">
            <div className="mega-menu__erp-links">
              {tab.links.map(({ to, label }) => (
                <Link key={to} to={to} className="mega-menu__link">
                  <div className="mega-menu__link-icon" style={{ background: tab.bg, color: tab.ic }}>→</div>
                  {label}
                </Link>
              ))}
            </div>
            <div className="mega-menu__erp-logo">
              <img className="mega-menu__partner-logo" src="/images/services/odoo_ready_partners_rgb.png" alt="Odoo Ready Partner" />
            </div>
          </div>
        ) : (
          <div className="mega-menu__grid">
            {tab.links.map(({ to, label }) => (
              <Link key={to} to={to} className="mega-menu__link">
                <div className="mega-menu__link-icon" style={{ background: tab.bg, color: tab.ic }}>→</div>
                {label}
              </Link>
            ))}
          </div>
        )}
        <div className="mega-menu__cta-bar">
          <p>
            Need something custom?
            <small>We tailor every engagement to your exact needs.</small>
          </p>
          <Link to="/contact"><button>Talk to Sales</button></Link>
        </div>
      </div>

      {/* Right: featured */}
      <div className="mega-menu__right">
        <p className="mega-menu__section-label">Why Choose Us</p>
        <p className="mega-menu__featured-title">End-to-end ownership on every project</p>
        <ul className="mega-menu__feature-list">
          {active === "erp" ? (
            <>
              <li className="dot-teal">Microsoft Dynamics 365 specialists</li>
              <li className="dot-green">Odoo certified implementation partner</li>
              <li className="dot-blue">End-to-end ERP support & managed services</li>
            </>
          ) : (
            <>
              <li className="dot-blue">Certified Odoo Partner</li>
              <li className="dot-teal">Microsoft Dynamics specialists</li>
              <li className="dot-green">AI-powered custom solutions</li>
              <li className="dot-blue">Founder involvement guaranteed</li>
            </>
          )}
        </ul>
        <Link to="/#services" className="mega-menu__cta-link">View all services →</Link>
      </div>
    </div>
  )
}

export default HowWeHelp
